<template>
    <ul>
        <li v-for="config in countedTicketsConfig" :key="config.id">
            <ProviderExpand :to-route="'/reachout/' + config.id"
                :providerwise-patient-count="config.patientCount"
                :total-count="config.patientCount.total.length"
                type="reachout">
                {{ config.title }}
            </ProviderExpand>
        </li>
    </ul>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import SidebarList from '.'
import ProviderExpand from './ProviderExpand'
import getReachTopics from '@/module/reachout/reachout-topics'

export default {
    name: 'sidebar-reachout-list',
    extends: SidebarList,

    // methods: {
    //     goToReachout(config) {
    //         if(Object.keys(config.patientCount).length > 0) {
    //             this.$router.push()
    //         }
    //     }
    // },

    computed: {
        ...mapState('provider', {
            ticketsConfig: state => state.ticketsConfig,
        }),
        ...mapGetters('provider', [
            'getTicketPatientByType'
        ]),
        countedTicketsConfig() {
            try {
                return this.ticketsConfig.map((config) => ({
                    ...config,
                    patientCount: this.getTicketPatientByType(config.category_id)
                }))
            } catch (error) {
                console.error(error)
                return this.ticketsConfig.map((config) => ({
                    ...config,
                    patientCount: {}
                }))
            }
            
        }
    },

    components: {
        ProviderExpand
    }

}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>